var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFriendEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.5C18.7614 22.5 21 20.2614 21 17.5C21 14.7386 18.7614 12.5 16 12.5C13.2386 12.5 11 14.7386 11 17.5C11 20.2614 13.2386 22.5 16 22.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 14.5C25.6645 14.499 26.8131 14.7696 27.8547 15.2903C28.8963 15.811 29.8021 16.5674 30.5001 17.4995",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.49951 17.4997C2.19756 16.5676 3.10338 15.8111 4.145 15.2904C5.18662 14.7697 6.33533 14.499 7.49987 14.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8042 26.9999C9.4611 25.6506 10.4841 24.5133 11.7565 23.7176C13.0288 22.9219 14.4992 22.5 15.9999 22.5C17.5005 22.5 18.971 22.9219 20.2433 23.7176C21.5157 24.5132 22.5387 25.6506 23.1956 26.9998",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50023 14.5C6.74128 14.4999 5.99803 14.2838 5.35727 13.8771C4.71652 13.4703 4.2047 12.8897 3.88159 12.2029C3.55847 11.5162 3.4374 10.7517 3.53251 9.99874C3.62762 9.24577 3.93498 8.5354 4.4187 7.95057C4.90243 7.36575 5.54255 6.93061 6.26432 6.69597C6.98609 6.46133 7.75972 6.43687 8.49487 6.62544C9.23002 6.81402 9.89635 7.20786 10.4161 7.76096C10.9358 8.31406 11.2874 9.0036 11.4299 9.74905",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5703 9.74907C20.7127 9.00349 21.0643 8.31382 21.584 7.7606C22.1038 7.20738 22.7702 6.81344 23.5054 6.62479C24.2406 6.43614 25.0144 6.46056 25.7362 6.69521C26.4581 6.92985 27.0983 7.36504 27.5821 7.94994C28.0659 8.53484 28.3733 9.24531 28.4684 9.99838C28.5635 10.7515 28.4424 11.516 28.1192 12.2029C27.796 12.8897 27.2841 13.4704 26.6432 13.8771C26.0024 14.2839 25.259 14.4999 24.4999 14.4999",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendEmpty);
export default __webpack_public_path__ + "static/media/friend-empty.1266dcb8f5802bbdf81e633a9713db84.svg";
export { ForwardRef as ReactComponent };